import NavigationService from '@ane/core/lib/services/NavigationService';
import { ROUTES } from '@ane/exp-data/lib/routes/Routes.constants';
import { FlightPivots, FlightViewConstants } from './flight.constants';
export const navigateToPivot = (flightId, pivot) => {
    NavigationService.navigateTo(`${ROUTES.flightDetails.location.pathname}/${flightId}/${pivot}`);
};
export const constructFlightDetailsURL = (flightId, workspaceId, managementGroup, pivot, view) => {
    const defaultId = !!flightId ? flightId.toLowerCase() : '';
    const pivotPath = pivot ? `/${pivot}` : '';
    const viewPath = view ? `/${view}` : '';
    const params = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
    const newPath = `${ROUTES.flightDetails.location.pathname}/${defaultId}${pivotPath}${viewPath}${params}`;
    return NavigationService.getCustomQueryParams(newPath);
};
export const toggleCompositionEditView = (flightId, workspaceId, managementGroup, toggle = true) => {
    const view = toggle ? FlightViewConstants.compositionEdit : undefined;
    const path = constructFlightDetailsURL(flightId, workspaceId, managementGroup, FlightPivots.composition, view);
    NavigationService.navigateTo(path);
};
export const toggleFlightEditView = (flightId, workspaceId, managementGroup, pivot, toggle = true) => {
    const view = toggle ? FlightViewConstants.edit : undefined;
    const path = constructFlightDetailsURL(flightId, workspaceId, managementGroup, pivot, view);
    NavigationService.navigateTo(path);
};
export const getFlightQueryParams = (managementGroup, workspaceId) => {
    const result = [];
    if (!!managementGroup)
        result.push(`managementGroup=${managementGroup}`);
    if (!!workspaceId)
        result.push(`workspaceId=${workspaceId}`);
    return result;
};
export const constructQueryString = (params) => {
    return `?${params.join('&')}`;
};

//# sourceMappingURL=FlightRoute.utils.js.map
